import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import {TextInput, TouchableWithoutFeedback, View} from 'react-native';

interface RenderCellParams {
  index: number;
  symbol: string;
  isFocused: boolean;
}

interface WebCodeFieldProps {
  value: string;
  onChangeText: (value: string) => void;
  cellCount: number;
  renderCell: (params: RenderCellParams) => React.ReactNode;
  autoFocus?: boolean;
  keyboardType?: string;
  textContentType?: string;
  autoComplete?: string;
}

// react-native-confirmation-code-field não tem build para web, então essa
// implementação reaproveita o mesmo `renderCell` das telas nativas: um
// TextInput invisível captura a digitação e as células visuais (fornecidas
// por `renderCell`) só espelham o valor digitado.
export const WebCodeField = forwardRef<TextInput, WebCodeFieldProps>(
  (
    {
      value,
      onChangeText,
      cellCount,
      renderCell,
      autoFocus,
      keyboardType,
      textContentType,
      autoComplete,
    },
    ref,
  ) => {
    const inputRef = useRef<TextInput>(null);
    useImperativeHandle(ref, () => inputRef.current as TextInput);

    return (
      <TouchableWithoutFeedback onPress={() => inputRef.current?.focus()}>
        <View style={{flexDirection: 'row', justifyContent: 'center'}}>
          <TextInput
            ref={inputRef}
            value={value}
            onChangeText={text =>
              onChangeText(text.replace(/\D/g, '').slice(0, cellCount))
            }
            keyboardType={keyboardType as any}
            textContentType={textContentType as any}
            autoComplete={autoComplete as any}
            autoFocus={autoFocus}
            maxLength={cellCount}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              opacity: 0,
            }}
          />
          {Array.from({length: cellCount}).map((_, index) =>
            renderCell({
              index,
              symbol: value[index] ?? '',
              isFocused: index === value.length,
            }),
          )}
        </View>
      </TouchableWithoutFeedback>
    );
  },
);
